import { ListingType } from '../../../modules/storefront/listingCardCreation/types'
import { EMPTY_STATE_COPY } from '../constants'

export const getEmptyStateCopy = (type?: ListingType) => {
  if (type === ListingType.BUTTON) {
    return EMPTY_STATE_COPY[ListingType.BUTTON]
  }
  if (type === ListingType.LISTING_CARD) {
    return EMPTY_STATE_COPY[ListingType.LISTING_CARD]
  }
  return EMPTY_STATE_COPY.COMING_SOON
}
